import { Actions, Mutations } from '@/store/enums/StoreEnums';
import StoreGettersService from '@/store/services/StoreGettersService';
import { useStore } from 'vuex';

export default class StoreDispatcherService extends StoreGettersService{

  constructor (store = useStore()) {super(store);}

  public setBreadcrumbs (params) {
    this.getStore().dispatch(Actions.SET_BREADCRUMB_ACTION, params);
  }

  public addBodyAttribute(data) {
    this.getStore().dispatch(Actions.ADD_BODY_ATTRIBUTE, data);
  }

  public addBodyClassname(className) {
    this.getStore().dispatch(Actions.ADD_BODY_CLASSNAME, className);
  }

  public removeBodyClassname(className) {
    this.getStore().dispatch(Actions.REMOVE_BODY_CLASSNAME, className);
  }

  public async buyApiCredits() {
    await this.getStore().dispatch(Actions.BUY_API_CREDITS, {});
  }
  public async resetApiToken() {
    await this.getStore().dispatch(Actions.RESET_API_TOKEN, {});
  }
  public async changeAutoRefreshCredits() {
    await this.getStore().dispatch(Actions.CHANGE_AUTO_REFRESH_CREDITS, {});
  }

  public changeLocale(lang) {
    this.getStore().dispatch(Actions.CHANGE_LOCALE, { locale: lang });
  }

  public async version() {
    await this.getStore().dispatch(Actions.VERSION);
  }

  public async resellerProgramStore (value) {
    await this.getStore().dispatch(Actions.RESELLER_PROGRAM_STORE, value);
  }

  public async requestManager (user_id, messenger, messenger_value, requestManagerSuccessfully: () => void) {
    await this.getStore().dispatch(Actions.REQUEST_MANAGER, {
      user_id: user_id,
      messenger: messenger,
      messenger_value: messenger_value
    })
      .then(response => requestManagerSuccessfully())
      .catch(err => console.log(err));
    this.getStore().commit(Mutations.SET_ERRORS_MANAGER, {});
  }
}
